import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import uniqueId from "lodash/uniqueId";

/** Material-UI */
import { TablePagination } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

import PaginationActions from "./PaginationActions";

const useStyles = makeStyles((theme) => ({
    toolbar: {
        boxShadow:'0px 2px 15px #0000000D',
        [theme.breakpoints.down("sm")]: {
            flexWrap: "wrap",
            justifyContent: "center",
            padding: 0,
        },
    },
    actions: {
        [theme.breakpoints.down("sm")]: {
            marginLeft: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: 8,
            width: "100%",
            position: "relative",
        },
    },
    paginationList: {
        opacity: 1,
        "& li": {            
            fontSize: "clamp(12px, 1vw, 1rem)",
            fontWeight: 400,
            lineHeight: 1.43,
        },
    },
    paginationRoot: {
        "& input": {
            opacity: 0,
            color: "#000",
        },
    },
    paginationCaption: {        
        fontSize: "clamp(12px, 1vw, 1rem)",
    },
    paginationSelect: {
        fontSize: "clamp(12px, 1vw, 1rem)",
        fontWeight: 400,
        lineHeight: 1.43,
        paddingBottom: 6,
    },
    paginationSelectIcon: {
        top: "calc(50% - 13px)",
        color: "#000",
    },
    visuallyhidden: {
        border: 0,
        clip: "rect(0 0 0 0)",
        height: 1,
        margin: -1,
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        width: 1,
    },
}));

const Pagination = forwardRef((props, ref) => {
    const {
        count,
        page,
        ActionsComponent,
        backIconButtonText,
        nextIconButtonText,
        labelRowsPerPage,
        labelDisplayedRows,
        SelectProps,
        position,
        ...rest
    } = props || {};

    const classes = useStyles();
    const { t } = useTranslation();
    const selectId = uniqueId(`${position || ""}-tpsi-`);

    return (
        <>
            <label htmlFor={selectId} className={classes.visuallyhidden}>
                {t("Liczba wierszy na stronie")}
            </label>

            <TablePagination
                ref={ref}
                ActionsComponent={PaginationActions}
                classes={{ toolbar: classes.toolbar, caption: classes.paginationCaption, actions: classes.actions }}
                SelectProps={{
                    classes: {
                        select: classes.paginationSelect,
                        icon: classes.paginationSelectIcon,
                    },
                    MenuProps: {
                        classes: {
                            list: classes.paginationList,
                        },
                    },
                    inputProps: {
                        id: selectId,
                        style: {
                            visibility: "hidden",
                        },
                    },
                }}
                backIconButtonText={t("Poprzednia strona")}
                nextIconButtonText={t("Następna strona")}
                labelRowsPerPage={t("Liczba wierszy na stronie{{colon}}", { colon: ":" })}
                labelDisplayedRows={({ from, to, count }) =>
                    `${from}-${to} ${t("z")} ${count !== -1 ? count : `${t("ponad")} ${to}`}`
                }
                count={count}
                page={count ? page : 0}
                {...rest}
            />
        </>
    );
});

export default Pagination;
